module.exports = {
  attribution: require('./attribution'),
  custom: require('./custom'),
  fullscreen: require('./fullscreen'),
  layer_selector: require('./layer_selector'),
  limits: require('./limits'),
  tiles: require('./tiles'),
  loader: require('./loader'),
  logo: require('./logo'),
  search: require('./search'),
  zoom: require('./zoom')
};



//////////////////
// WEBPACK FOOTER
// ./~/internal-carto.js/src/vis/overlays/index.js
// module id = 1693
// module chunks = 6